<template>
  <PageLayout>
    <component
      v-if="_config"
      :is="
        _config.app_config.configValue.template
          ? _config.app_config.configValue.template.login || 'default1'
          : 'default1'
      "
    />
    <!-- <component v-if="_config" :is="'default1'" /> -->
  </PageLayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import PageLayout from '@c/layout/PageLayout'
export default {
  mixins: [appConfigMixins],
  components: {
    PageLayout,
    default1: () => import('@t/Login/default1'),
    Yabo01: () => import('@t/Login/Yabo01'),
    kszl: () => import('@t/Login/kszl'),
    kslight: () => import('@t/Login/kslight'),
    ksob: () => import('@t/Login/ksob'),
    ob: () => import('@t/Login/ob'),
    nox: () => import('@t/Login/nox'),
    dfcp: () => import('@t/Login/dfcp')
  },
  computed: {}
}
</script>
